import {
  LENGTH_UNITS,
  LENGTH_UNIT_MAP,
  type LengthUnitKey,
  type LengthUnit,
} from "@/data/lengthUnits";

export const FEET_PER_METER = 1 / 0.3048; // 3.28083989501...
export const METERS_PER_FOOT = 0.3048;

/** Convert `value` from `from` unit to `to` unit. */
export function convertLength(value: number, from: LengthUnitKey, to: LengthUnitKey): number {
  if (!Number.isFinite(value)) return NaN;
  const meters = value * LENGTH_UNIT_MAP[from].meters;
  return meters / LENGTH_UNIT_MAP[to].meters;
}

/** Convert a value to all supported units. Returns array of { unit, value }. */
export function convertToAll(value: number, from: LengthUnitKey): { unit: LengthUnit; value: number }[] {
  const meters = value * LENGTH_UNIT_MAP[from].meters;
  return LENGTH_UNITS.map((u) => ({ unit: u, value: meters / u.meters }));
}

export function feetToMeter(ft: number): number {
  return ft * METERS_PER_FOOT;
}

export function meterToFeet(m: number): number {
  return m * FEET_PER_METER;
}

export { LENGTH_UNITS, LENGTH_UNIT_MAP };
export type { LengthUnitKey, LengthUnit };
